export const DRAWER_WIDTH = 275;